import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	changeSeveritySuccess: {
		id: 'jira-servicedesk-ai-context-ops-panel.major-incident.change-severity-success',
		defaultMessage: 'Updated severity of the incident',
		description: 'Success toast message when user change severity of an issue.',
	},
});
